import { Navigate } from 'react-router-dom';
import AuthLayout from '../layout/AuthLayout';
import QuanLyDoiTac from '../pages/quanlydoitac';

import DanhSachChienDich from '../pages/quanlychiendich';
import ThemChienDich from '../pages/quanlychiendich/components/themChienDich';
import SuaChienDich from '../pages/quanlychiendich/components/suaChienDich';

import QuanLyThongBao from '../pages/quanlythongbao';
import ThemThongBao from '../pages/quanlythongbao/components/themThongBao';
import SuaThongBao from '../pages/quanlythongbao/components/suaThongBao';
import SaoChepThongBao from '../pages/quanlythongbao/components/saoChepThongBao';

import QuanLyPopUp from '../pages/quanlypopup';
import SuaPopup from '../pages/quanlypopup/components/suaPopup';
import SaoChepPopup from '../pages/quanlypopup/components/saoChepPopup';

import QuanLyBanner from '../pages/quanlybanner';
import SuaBanner from '../pages/quanlybanner/components/suaBannner';
import SaoChepBanner from '../pages/quanlybanner/components/saoChepBanner';

import Thongkechiendich from '../pages/thongkechiendich';

import QuanTriNguoiDung from '../pages/quantringuoidung';
import DanhSachNhomQuyen from '../pages/vaitroquyenhan';
import DanhSachTinhNang from '../pages/quanlytinhnang';
import ThongKeThongBao from '../pages/thongkethongbao';
import CronJobPage from '../pages/cronjob';

// routes
const userRoutes = [
  {
    path: '/',
    element: <AuthLayout></AuthLayout>,
  },
 
  {
    path: '/quan-ly-chien-dich',
    element: (
      <AuthLayout>
        <DanhSachChienDich />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-chien-dich/them-chien-dich',
    element: (
      <AuthLayout>
        <ThemChienDich />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-chien-dich/:campaignId/chinh-sua-chien-dich',
    element: (
      <AuthLayout>
        <SuaChienDich />
      </AuthLayout>
    ),
  },

  {
    path: '/quan-ly-banner',
    element: (
      <AuthLayout>
        <QuanLyBanner />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-banner/:bannerId/chinh-sua-banner',
    element: (
      <AuthLayout>
        <SuaBanner />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-banner/:bannerId/sao-chep-banner',
    element: (
      <AuthLayout>
        <SaoChepBanner />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-popup',
    element: (
      <AuthLayout>
        <QuanLyPopUp />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-popup/:popupId/chinh-sua-popup',
    element: (
      <AuthLayout>
        <SuaPopup />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-popup/:popupId/sao-chep-popup',
    element: (
      <AuthLayout>
        <SaoChepPopup />
      </AuthLayout>
    ),
  },

   {
    path: '/quan-ly-thong-bao',
    element: (
      <AuthLayout>
        <QuanLyThongBao />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-thong-bao/them-thong-bao',
    element: (
      <AuthLayout>
        <ThemThongBao />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-thong-bao/:notificationId/chinh-sua-thong-bao',
    element: (
      <AuthLayout>
        <SuaThongBao />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-thong-bao/:notificationId/sao-chep-thong-bao',
    element: (
      <AuthLayout>
        <SaoChepThongBao />
      </AuthLayout>
    ),
  },

  {
    path: '/thong-ke-chien-dich',
    element: (
      <AuthLayout>
        <Thongkechiendich />
      </AuthLayout>
    ),
  },

    {
    path: '/thong-ke-thong-bao',
    element: (
      <AuthLayout>
        <ThongKeThongBao />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-cron-job',
    element: (
      <AuthLayout>
        <CronJobPage />
      </AuthLayout>
    ),
  },

    {
    path: '/quan-ly-doi-tac',
    element: (
      <AuthLayout>
        <QuanLyDoiTac />
      </AuthLayout>
    ),
  },
  
  {
    path: '/quan-ly-nguoi-dung',
    element: (
      <AuthLayout>
        <QuanTriNguoiDung />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-nhom-quyen',
    element: (
      <AuthLayout>
        <DanhSachNhomQuyen />
      </AuthLayout>
    ),
  },
  {
    path: '/quan-ly-tinh-nang',
    element: (
      <AuthLayout>
        <DanhSachTinhNang />
      </AuthLayout>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];

export default userRoutes;
